import React from 'react';
import columnsWidth from '../../constants/columnsWidth';
import sortConstants from '../../constants/sortConstants';
import TypeCell from '../cells/TypeCell';
import NumberCell from '../cells/NumberCell';
import CreateDateCell from '../cells/CreateDateCell';
import StatusCell from '../cells/StatusCell';
import SubjectCell from '../cells/SubjectCell';
import DoneDateCell from '../cells/DoneDateCell';
import AppointedWorkersCell from '../cells/AppointedWorkersCell';
import ResponsibleWorkerCell from '../cells/ResponsibleWorkerCell';
import AddressesCell from '../cells/AddressesCell';
import documentEditMode from '../../constants/documentEditMode';
import DocEditCell from '../cells/DocEditCell';
import ResponseTimeCell from '../cells/ResponseTimeCell';
import { Icon, Tooltip } from 'antd';
import OrgsCell from '../cells/OrgsCell';
import { docTypes } from '../../constants/documents.constants';

const getPopupContainer = () => document.getElementById('docTableContainer');

export const getColumns = (
  sortParam,
  sortOrder,
  handleEditNumberDateClick,
  expandedRows
) => [
  {
    width: columnsWidth.type,
    title: <div style={{ marginLeft: '10px' }}>Тип</div>,
    key: 'type',
    sorter: true,
    sortOrder: sortParam === sortConstants.type && sortOrder,
    render: (_text, record) => (
      <TypeCell
        record={record}
        getPopupContainer={getPopupContainer}
      />
    ),
  },
  {
    width: columnsWidth.doc_number,
    title: <div style={{ whiteSpace: 'nowrap' }}>Номер</div>,
    dataIndex: 'docNumber',
    key: 'doc_number',
    sorter: true,
    sortOrder: sortParam === sortConstants.doc_number && sortOrder,
    render: (_, record) => (
      <NumberCell
        record={record}
        handleEditNumberDateClick={handleEditNumberDateClick}
        getPopupContainer={getPopupContainer}
      />
    ),
  },
  {
    width: columnsWidth.createDate,
    title: (
      <div>
        <span>Даты</span>
        {/* <span style={{ float: 'right' }}>
          <Tooltip
            mouseLeaveDelay={0}
            title="по дате ответа"
          >
            <Icon
              type="book"
              style={{
                color:
                  sortParam === sortConstants.DoneDate ? '#0995ed' : '#afafaf',
                marginLeft: '10px',
                cursor: 'pointer',
              }}
              onClick={(e) => {
                e.stopPropagation();
              }}
            />
          </Tooltip>

          <Tooltip
            mouseLeaveDelay={0}
            title="по сроку ответа"
          >
            <Icon
              type="clock-circle"
              style={{
                color:
                  sortParam === sortConstants.deadlineDate
                    ? '#0995ed'
                    : '#afafaf',
                marginLeft: '10px',
                cursor: 'pointer',
              }}
              onClick={(e) => {
                e.stopPropagation();
              }}
            />
          </Tooltip>
        </span> */}
      </div>
    ),
    key: 'createDate',
    sorter: true,
    sortOrder:
      (sortParam === sortConstants.createDate ||
        sortParam === sortConstants.DoneDate ||
        sortParam === sortConstants.deadlineDate) &&
      sortOrder,
    defaultSortOrder: 'descend',
    render: (_, record) => (
      <div style={{ display: 'flex', gap: '5px', flexDirection: 'column' }}>
        <CreateDateCell record={record} />
        <DoneDateCell
          record={record}
          getPopupContainer={getPopupContainer}
        />
        {(record?.type?.id === docTypes.incoming ||
          record?.type?.id === docTypes.citizenAppeal) && (
          <ResponseTimeCell
            record={record}
            getPopupContainer={getPopupContainer}
          />
        )}
      </div>
    ),
    /*
    render: (text, record) => (
      <DateCell
        text={text}
        record={record}
        handleEditNumberDateClick={handleEditNumberDateClick}
        getPopupContainer={getPopupContainer}
      />
    ),
    */
  },
  {
    width: columnsWidth.status,
    title: 'Статус',
    key: 'status',
    sortOrder: sortParam === sortConstants.status && sortOrder,
    sorter: true,
    render: (_text, record) => (
      <StatusCell
        record={record}
        getPopupContainer={getPopupContainer}
      />
    ),
  },
  {
    width: columnsWidth.topic,
    title: 'Тема',
    key: 'topicId',
    align: 'left',
    sortOrder: sortParam === sortConstants.topicId && sortOrder,
    sorter: true,
    render: (_text, record) => (
      <SubjectCell
        record={record}
        getPopupContainer={getPopupContainer}
      />
    ),
  },
  // {
  //   width: columnsWidth.DoneDate,
  //   title: 'Дата ответа',
  //   key: 'DoneDate',
  //   align: 'left',
  //   sorter: true,
  //   sortOrder: sortParam === sortConstants.DoneDate && sortOrder,
  //   render: (_text, record) => (
  //     <DoneDateCell
  //       record={record}
  //       getPopupContainer={getPopupContainer}
  //     />
  //   ),
  // },
  // {
  //   width: columnsWidth.deadlineDate,
  //   title: 'Срок ответа',
  //   key: 'deadlineDate',
  //   align: 'left',
  //   sorter: true,
  //   sortOrder: sortParam === sortConstants.deadlineDate && sortOrder,
  //   render: (_text, record) => (
  //     <ResponseTimeCell
  //       record={record}
  //       getPopupContainer={getPopupContainer}
  //     />
  //   ),
  // },
  {
    width: columnsWidth.ResponsibleWorker,
    title: <div style={{ whiteSpace: 'nowrap' }}>Ответственный</div>,
    key: 'ResponsibleWorker',
    sorter: true,
    sortOrder: sortParam === sortConstants.ResponsibleWorker && sortOrder,
    render: (_text, record) => (
      <ResponsibleWorkerCell
        record={record}
        getPopupContainer={getPopupContainer}
      />
    ),
  },
  {
    width: columnsWidth.DocExecuter,
    title: <div style={{ whiteSpace: 'nowrap' }}>Исполнители</div>,
    key: 'DocExecuter',
    render: (_text, record) => (
      <>
        <AppointedWorkersCell
          rowOpened={expandedRows[record.id]}
          single
          record={record}
        />
        {expandedRows[record.id] && (
          <AppointedWorkersCell
            rowOpened={expandedRows[record.id]}
            record={record}
            documentEditMode={documentEditMode}
          />
        )}
      </>
    ),
  },
  {
    width: columnsWidth.adresses,
    title: <div style={{ whiteSpace: 'nowrap' }}>Адрес</div>,
    key: 'adresses',
    render: (_text, record) => (
      <>
        <AddressesCell
          record={record}
          single
          rowOpened={expandedRows[record.id]}
        />
        {expandedRows[record.id] && (
          <AddressesCell
            record={record}
            single={false}
            rowOpened={expandedRows[record.id]}
            documentEditMode={documentEditMode}
          />
        )}
      </>
    ),
  },
  {
    width: columnsWidth.orgs,
    title: <div style={{ whiteSpace: 'nowrap' }}>Организация</div>,
    key: 'orgs',
    render: (_text, record) => (
      <>
        <OrgsCell
          record={record}
          single
          rowOpened={expandedRows[record.id]}
        />
        {expandedRows[record.id] && (
          <OrgsCell
            record={record}
            single={false}
            rowOpened={expandedRows[record.id]}
          />
        )}
      </>
    ),
  },
  {
    width: columnsWidth.DocChange,
    title: <div style={{ whiteSpace: 'nowrap' }}></div>,
    key: 'DocChange',
    render: (_, record) => (
      <DocEditCell
        record={record}
        getPopupContainer={getPopupContainer}
      />
    ),
  },
  // {
  //   width: columnsWidth.related_objects,
  //   title: <div style={{ whiteSpace: 'nowrap' }}>Связанные объекты</div>,
  //   key: 'related_objects',
  // },
];
